/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Score_Signal_VerifyInputs */

const en_directory_detail_score_signal_verify = /** @type {(inputs: Directory_Detail_Score_Signal_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify`)
};

const zh_directory_detail_score_signal_verify = /** @type {(inputs: Directory_Detail_Score_Signal_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建议核验`)
};

/**
* | output |
* | --- |
* | "Verify" |
*
* @param {Directory_Detail_Score_Signal_VerifyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_signal_verify = /** @type {((inputs?: Directory_Detail_Score_Signal_VerifyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Signal_VerifyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_signal_verify(inputs)
	return zh_directory_detail_score_signal_verify(inputs)
});
export { directory_detail_score_signal_verify as "directory.detail.score_signal.verify" }